package dev.helpmycity.`data`.local.database

import androidx.room3.RoomDatabaseConstructor

public actual object HelpMyCityDatabaseConstructor : RoomDatabaseConstructor<HelpMyCityDatabase> {
  actual override fun initialize(): HelpMyCityDatabase = dev.helpmycity.`data`.local.database.HelpMyCityDatabase_Impl()
}
